"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var toolkit_1 = require("@reduxjs/toolkit");
var constants_1 = require("./constants");
exports.setIsFullScreen = function (isFullScreen) {
    return toolkit_1.createAction(constants_1.SET_IS_FULL_SCREEN)(isFullScreen);
};
exports.setIsChromecastDevicesVisible = function (isVisible) {
    return toolkit_1.createAction(constants_1.SET_IS_CHROMECAST_DEVICES_VISIBLE)(isVisible);
};
exports.setRestrictedMessage = function (restrictedMessage) {
    return toolkit_1.createAction(constants_1.SET_RESTRICTED_MESSAGE)(restrictedMessage);
};
exports.setLastCheckedContent = function (content) {
    return toolkit_1.createAction(constants_1.SET_LAST_CHECKED_CONTENT)(content);
};
exports.setPlayerState = function (props) { return toolkit_1.createAction(constants_1.SET_PLAYER_STATE)(props); };
exports.resetPlayerState = function () { return toolkit_1.createAction(constants_1.RESET_PLAYER_STATE)(); };
//# sourceMappingURL=actions.js.map